import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { SegmentBUMapModel } from "../../models/SegmentBUMapModel";
import SegmentBUMapService from "../../services/SegmentBUMapService";
import SegmentBUMapSlice from "../slices/SegmentBUMapSlice";
import { RootState } from "../store";

export const Actions = SegmentBUMapSlice.actions;

export const fetchSegmentBUMaps = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(Actions.setIsSegmentBUMapsFetching(true));
    const response: SegmentBUMapModel[] =
      await SegmentBUMapService.getSegmentBUMaps();
    dispatch(Actions.setSegmentBUMap(response));
    dispatch(Actions.setIsSegmentBUMapsFetching(false));
  };
};
